import { FC } from 'react'
import { Typography, Row, Alert, Icon } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { UserReferralStats } from '@repo/services'
import { ToDate } from '@repo/shared/components'

export const InviteDetailsNoKyc: FC<{ item: UserReferralStats }> = ({
  item,
}) => {
  const { t } = useTranslate()
  return (
    <div className=' flex flex-col  items-center    w-full  pb-md  '>
      <Row className='gap-2xs items-center justify-between mb-md'>
        <Typography size='xs' color='text-neutral-surface-60'>
          {t('inviteTable_header_joinedAt')}
        </Typography>
        <Typography size='xs' color='text-neutral-surface-60'>
          <ToDate date={new Date(item.joinedAt ?? '')} />
        </Typography>
      </Row>
      <Alert
        color='alert'
        caption={t('inviteTable_label_no_kyc_description')}
        icon={<Icon name='AlertTriangle' className='w-4 h-4' />}
      />
    </div>
  )
}
